module.exports = __webpack_public_path__ + "72317b8c83dd3a2e0de65b6bbc623180.jpg";